import { LitElement, html, css } from 'lit'

class ContextualMenu extends LitElement {
  static styles = css`
    :host {
      display: block;
    }
  `
  static properties = {}

  constructor() {
    super()
    this._selectedItem = null
    this._wait = false
    this._observer = null

    window.addEventListener('resize', this.handleResize.bind(this))

  }

  handleResize() {
    this._observer?.disconnect()
    this.initScrollSpyObserver()
  }

  firstUpdated() {

    this.initScrollSpyObserver()

    this.addEventListener('contextual-menu-item-selected', (e) => {
      this.setSelectedItem(e.detail)
      //Hack to not update while scrolling when the user clicks on a menu item
      this._wait = true
      setTimeout(() => {
        this._wait = false
      }, 800)
    })

    this._items = this.querySelectorAll('contextual-menu-item')
  }

  initScrollSpyObserver() {
    const settings = {
      root: null,
      rootMargin: `-177px 0px -${window.innerHeight - 177}px 0px`,
      threshold: 0,
    }
    let observer = new IntersectionObserver((entries, observer) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          if (this._wait) return

          const divider = this.getPreviousDivider(entry.target)
          const id = divider?.querySelector('h2').id
          if (!id) {

            window.history.replaceState(
              null,
              null,
              window.location.pathname + window.location.search,
            )
          } else {
            console.log('intersecting', entry.target)
            window.history.replaceState(
              null,
              null,
              `${window.location.pathname + window.location.search}#${id}`,
            )
          }
          this.setSelectedItem(id)
        }
      })
    }, settings)

    let dividers = document.querySelectorAll('main > *')

    dividers.forEach(function(divider) {
      observer.observe(divider)
    })

    this._observer = observer
  }

  getPreviousDivider = function(elem) {
    if (elem.matches('.divider')) return elem
    let sibling = elem.previousElementSibling
    while (sibling) {
      if (sibling.matches('.divider')) return sibling
      sibling = sibling.previousElementSibling
    }
  }

  setSelectedItem(id) {
    let hasSelected = false
    this._items.forEach((item, i) => {
      if (item.dataset.id === id) {
        hasSelected = true
        item.setAttribute('selected', '')
        this.querySelector('contextual-menu-track').scrollTo({
          left: item.offsetLeft - ((window.innerWidth / 2) - (item.offsetWidth / 2)),
          behavior: 'smooth',
        })
      } else {
        item.removeAttribute('selected')
      }
    })
    if (!hasSelected) {
      this.querySelector('contextual-menu-track').scrollTo({
        left: 0,
        behavior: 'smooth',
      })
    }
  }

  render() {
    return html`
      <slot></slot>`
  }
}

customElements.define('contextual-menu', ContextualMenu)

class ContextualMenuItem extends LitElement {
  static styles = css``
  static properties = {
    selected: { type: Boolean, reflect: true },
  }

  constructor() {
    super()
    this.handleAnchorClick = this.handleAnchorClick.bind(this)
    this._anchor = this.querySelector('a')
    this._anchor.addEventListener('click', (e) => this.handleAnchorClick(e))
  }

  handleAnchorClick(e) {
    e.preventDefault()
    const id = e.currentTarget.href.split('#')[1]
    const targetDivider = document.getElementById(id).closest('.divider')
    const parent = this.closest('contextual-menu')
    let scrollOffset = parent.offsetHeight

    if (window.innerWidth > 1100) {
      scrollOffset += document.querySelector('.header').offsetHeight
    } else {
      scrollOffset += document.querySelector('.header-mobile').offsetHeight
    }

    window.scrollTo({
      behavior: 'smooth',
      top:
        targetDivider.offsetTop - scrollOffset,
    })
    window.history.replaceState(null, null, `#${id}`)
    this.dispatchEvent(
      new CustomEvent('contextual-menu-item-selected', {
        detail: id,
        bubbles: true,
      }),
    )
  }

  render() {
    return html`
      <slot></slot> `
  }
}

customElements.define('contextual-menu-item', ContextualMenuItem)

class ContextualMenuToggle extends LitElement {
  static styles = css`
    button {
    }
  `
  static properties = {
    isMobile: { type: Boolean },
  }

  constructor() {
    super()
    window.addEventListener('resize', () => {
      this.isMobile = window.matchMedia('(max-width: 1100px)').matches
    })
  }

  firstUpdated() {
    this.isMobile = window.matchMedia('(max-width: 1100px)').matches
  }

  render() {
    if (this.isMobile) {
      return html`
        <button>
          <slot></slot>
        </button>
      `
    } else {
      return html`
        <slot></slot>`
    }
  }
}

customElements.define('contextual-menu-toggle', ContextualMenuToggle)


class ContextualMenuTrack extends LitElement {
  static styles = css`
    :host {
      display: flex;
      align-items: center;
      justify-content: flex-start;

      overflow: auto;
      -webkit-overflow-scrolling: touch;
      scrollbar-width: none;
      -ms-overflow-style: none;
    }
  `

  constructor() {
    super()
  }

  firstUpdated() {
  }

  render() {
    return html`
      <slot></slot>`
  }
}

customElements.define('contextual-menu-track', ContextualMenuTrack)